import {z} from 'zod'

import {tzDateFromIso} from 'src/api/zod-helpers'

export const JobDocumentRawSchema = z.object({
    id: z.string().uuid(),
    name: z.string(),
    original_filename: z.string(),
    content_type: z.string(),
    size_bytes: z.number().int(),
    created_at: z.string(),
})

export type JobDocumentRaw = z.infer<typeof JobDocumentRawSchema>

export const JobDocumentSchema = JobDocumentRawSchema.transform((raw) => ({
    ...raw,
    created_at: tzDateFromIso.parse(raw.created_at),
}))

export type JobDocument = z.infer<typeof JobDocumentSchema>

export const AssignDocumentRequestSchema = z.object({
    document_id: z.string().uuid(),
})

export type AssignDocumentRequest = z.infer<typeof AssignDocumentRequestSchema>
